import React from "react";

const StatsSection = () => {
  return (
    <section className="stats-section">
      <div className="container">
        <div className="row text-center g-4">
          <div className="col-md-3 col-6">
            <div className="stat-number">10K+</div>
            <p className="mb-0 text-white-50">Active BC Agents</p>
          </div>
          <div className="col-md-3 col-6">
            <div className="stat-number">10+</div>
            <p className="mb-0 text-white-50">Partner Banks</p>
          </div>
          <div className="col-md-3 col-6">
            <div className="stat-number">1M+</div>
            <p className="mb-0 text-white-50">Transactions / Month</p>
          </div>
          <div className="col-md-3 col-6">
            <div className="stat-number">20+</div>
            <p className="mb-0 text-white-50">States Covered</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
